import { createAction } from "@reduxjs/toolkit";
import { action } from "../../actions";
export const viewStreamRequest = createAction(action("VIEW_STREAM_REQUEST"));
export const viewStreamSuccess = createAction(action("VIEW_STREAM_SUCCESS"));
export const viewStreamFailure = createAction(action("VIEW_STREAM_FAILURE"));
export const stopViewStreamRequest = createAction(action("STOP_VIEW_STREAM_REQUEST"));
export const stopViewStreamSuccess = createAction(action("STOP_VIEW_STREAM_SUCCESS"));
export const stopViewStreamFailure = createAction(action("STOP_VIEW_STREAM_FAILURE"));
export const viewStreamIceCandidate = createAction(action("VIEW_STREAM_ICE_CANDIDATE"));
export const viewStreamIceStateChange = createAction(action("VIEW_STREAM_ICE_STATE_CHANGE"));
export const viewStreamConnectionStateChange = createAction(action("VIEW_STREAM_CONNECTION_STATE_CHANGE"));
export const viewState = createAction(action("VIEW_STATE"));
